import { Link } from '@tanstack/react-router';

import { ChevronLeft } from 'lucide-react';


/** Shared sub-page header: a desktop title/subtitle block and a mobile bar with
 * a back chevron to the settings hub (.pen mobile pattern). `actions` render on
 * the desktop header's right edge (e.g. the Team "Invite member" button). */
function PageHeader({ title, subtitle, actions }) {
  return (
    <>
      {/* Mobile bar */}
      <div className="flex h-14 items-center gap-2 border-b border-hairline px-1 lg:hidden">
        <Link aria-label="Back" className="grid size-9 place-items-center" to="/app/settings">
          <ChevronLeft className="size-[22px] text-ink" />
        </Link>

        <span className="text-[17px] font-semibold tracking-[-0.3px] text-ink">{title}</span>
      </div>

      {/* Desktop header */}
      <div className="hidden items-start justify-between gap-3 lg:flex">
        <span className="flex flex-col gap-1">
          <h2 className="text-lg font-semibold tracking-[-0.3px] text-ink">{title}</h2>

          {subtitle
            ? <span className="text-table text-ink-subtle">{subtitle}</span>
            : null}
        </span>

        {actions}
      </div>
    </>
  );
}

PageHeader.displayName = 'PageHeader';
export default PageHeader;
